import { createSlice } from '@reduxjs/toolkit'

export const configSlice = createSlice({
  name: 'globalInfo',
  initialState: {
    accessToken:"",
    roles:[""],
    isAdministrator:false,
    isOwner:false,
    isPowerUser:false,
    hasCallRecordings:false,
    nameSpace:"https://example.com/",
    companies:"[]",
    currentCompanyId: ""
  },
  reducers: {
    setCompanies: (state, action) => {
      state.companies = action.payload
    },
    setCurrentCompanyId: (state, action) => {
      state.currentCompanyId = action.payload
    },
    setRoles: (state, action) => {
      state.roles = (action.payload || []).filter(Boolean);
      const normalizedRoles = state.roles.map((role) => role.toLowerCase().replace(/[\s-]/g, ""));
      state.isAdministrator = normalizedRoles.includes("administrator")
      state.isOwner = normalizedRoles.includes("businessowner")
      state.isPowerUser = normalizedRoles.includes("poweruser")
      state.hasCallRecordings = normalizedRoles.includes("callrecordingsubscriber")
    },
    
  },
})

// Action creators are generated for each case reducer function
export const { setRoles, setCompanies, setCurrentCompanyId } = configSlice.actions

export default configSlice.reducer
